const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#111"
      stroke="#111"
      strokeWidth={0.3}
      d="M15.286 8.79h-6.57c-.691 0-1.223.183-1.595.549-.372.365-.558.887-.558 1.566v2.86c0 .678.186 1.2.558 1.565.372.366.904.549 1.595.549h6.57c.69 0 1.222-.183 1.595-.55.372-.365.558-.886.558-1.563v-2.861c0-.679-.186-1.2-.558-1.566-.373-.366-.904-.55-1.595-.55Zm-.146 1.68c.198 0 .35.054.454.161.104.108.156.264.156.469v2.46c0 .206-.052.362-.156.47-.104.107-.256.16-.454.16H8.864c-.2 0-.352-.053-.456-.16-.105-.108-.157-.264-.157-.47V11.1c0-.205.052-.361.157-.469.104-.107.256-.161.456-.161h6.275ZM21.196 5.67H2.804a.755.755 0 0 1-.57-.247A.819.819 0 0 1 2 4.84c0-.225.078-.42.235-.589A.749.749 0 0 1 2.804 4h18.392a.75.75 0 0 1 .571.252.837.837 0 0 1 .235.589.82.82 0 0 1-.235.582.757.757 0 0 1-.57.248ZM21.196 20.67H2.804a.755.755 0 0 1-.57-.248A.819.819 0 0 1 2 19.84c0-.224.078-.42.235-.588A.75.75 0 0 1 2.804 19h18.392c.224 0 .415.084.571.252a.837.837 0 0 1 .235.588.82.82 0 0 1-.235.582.757.757 0 0 1-.57.248Z"
    />
  </svg>
)
export default SvgComponent
